import React, { FC, useState } from 'react';
import { Button } from '../../../../Partials/Button';
import { SvgIcon } from '../../../../../SvgIcon/SvgIcon';

interface AddNoteButtonProps {
  onClick: () => void;
  isModalOpened: boolean;
  label: string;
}

export const AddNoteButton: FC<AddNoteButtonProps> = (props) => {
  const { onClick, isModalOpened } = props;

  return (
    <Button
      onClick={onClick}
      type="solid"
      size="large"
      tier="secondary"
      className="addNoteButton"
      aria-haspopup
      aria-expanded={isModalOpened}
    >
      <span className="addNoteButton__label">
        <span>{props.label}</span>
        <SvgIcon
          iconName="s-plus"
          className="addNoteButton__icon"
        />
      </span>
    </Button>
  );
};
